<div class="video-questions-wrapper"
     [@routeAnimations]="activeQuestionIndex">
  <router-outlet #videoOutlet="outlet"></router-outlet>
</div>
